import type { OasDocument3XExtended } from '@ipfabric/utils';
import {
  type OasOperationTable,
  isOasOperationTable,
} from '@ipfabric/utils/oas/OasOperationTable';

export const getOasOperationTable = (
  oas: OasDocument3XExtended,
  apiEndpoint: string,
): OasOperationTable | null => {
  const oasOperation = oas.paths?.[apiEndpoint]?.post;
  if (isOasOperationTable(oasOperation)) {
    return oasOperation;
  }

  return null;
};
